import script from "./contactBox.vue?vue&type=script&setup=true&lang=js"
export * from "./contactBox.vue?vue&type=script&setup=true&lang=js"

import "./contactBox.vue?vue&type=style&index=0&id=0e3b0b38&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3b0b38"]])

export default __exports__